import React, { useRef, useState, useEffect } from 'react';
import cn from 'classnames';

import lexiang from '@/asserts/images/deep-customers/simple/icon-lexiang.svg';
import qidian from '@/asserts/images/deep-customers/simple/icon-tencent-qidian.svg';
import game from '@/asserts/images/deep-customers/simple/icon-game.svg';
import tapd from '@/asserts/images/deep-customers/simple/icon-tapd.svg';
import map from '@/asserts/images/deep-customers/simple/icon-map.svg';
import healthcare from '@/asserts/images/deep-customers/simple/icon-healthcare.svg';
import andon from '@/asserts/images/deep-customers/simple/icon-andon.svg';
import midas from '@/asserts/images/deep-customers/simple/icon-midas.svg';

import meetingSquare from '@/asserts/images/deep-customers/carousels/square-meeting.svg';
import meetingImg from '@/asserts/images/deep-customers/carousels/img-meeting.png';
import chuxingSquare from '@/asserts/images/deep-customers/carousels/square-chuxing.svg';
import chuxingImg from '@/asserts/images/deep-customers/carousels/img-chuxing.png';
import cmsIcon from '@/asserts/images/deep-customers/carousels/icon-cms.svg';
import cmsImg from '@/asserts/images/deep-customers/carousels/img-cms.png';
import anquanSquare from '@/asserts/images/deep-customers/carousels/square-anquan.svg';
import anquanImg from '@/asserts/images/deep-customers/carousels/img-anquan.png';

import toLeftDiasbled from '@/asserts/images/btn/to-left-disabled.svg';
import toRightDiasbled from '@/asserts/images/btn/to-right-disabled.svg';
import toLeft from '@/asserts/images/btn/to-left.svg';
import toRight from '@/asserts/images/btn/to-right.svg';
import { getSite, PLATFORM } from '@/common/constants/platform-constants';
import s from './index.module.less';

const carousels = [
  {
    key: 'meeting',
    img: meetingImg,
    icon: meetingSquare,
    name: '腾讯会议',
    subTitle: 'ifBook 助力腾讯会议研发提效',
    des: '腾讯会议作为 ifBook 从零到一落地第一战，ifBook 为业务提供统一的 API 治理工具，实现了一站式开发和管理能力，和会议多样化协议管理，Proto 规范性检查等需求，帮助腾讯会议研发团队提效，实现腾讯会议后台开发 95% 的用户渗透率。',
  },
  {
    key: 'chuxing',
    img: chuxingImg,
    icon: chuxingSquare,
    name: '腾讯智慧出行',
    subTitle: 'ifBook 打通腾讯智慧出行研发测试团队高效协同',
    des: 'ifBook 为腾讯地图，智慧物联等业务打通了共享协同的团队合作模式，以数据的中心化管理为基础，建立了高效分享公开文档，接入流水线门禁，打通与其他 DevOps 平台的联动，解决多人协作冲突问题等，使业务在敏捷迭代中快速响应，增强核心竞争力。',
  },
  {
    key: 'anquan',
    img: anquanImg,
    icon: anquanSquare,
    name: '腾讯安全',
    subTitle: 'ifBook 助力腾讯安全测试左移，强化质量防火墙',
    des: 'ifBook 助力包含云安全，业务安全，数据安全以及游戏安全等大大小小的云业务的测试人员使用低代码方式高效搭建自动化测试场景及任务，并提供可视化的测试报告和触发触达机制，及时的问题反馈，提升系统稳定性。实现了测试左移，为安全业务铸造了质量防火墙。',
  },
  {
    key: 'cms',
    img: cmsImg,
    ...getSite() === PLATFORM.STANDALONE_WOA ? {
      icon: cmsIcon,
      name: '招商证券',
      subTitle: 'ifBook 助力招商证券打通中心化 API 管理 ',
      des: 'ifBook 打通招商证券私有化交付，实现了招商证券的私有仓库Swagger 导入，规范的协议文件管理，权限管理，以及中心化的API管理能力，为招商证券软件开发流程降本增效，提高 API 的质量和有效性，推动金融行业数字化发展。',
    } : {
      name: '某大型券商公司',
      subTitle: 'ifBook 助力某大型券商公司打通中心化 API 管理 ',
      des: 'ifBook 为某大型券商公司打通私有化交付，实现了该证券公司的私有仓库 Swagger 导入，规范的协议文件管理，权限管理，以及中心化的 API 管理能力，为该证券公司的软件开发流程降本增效，提高 API 的质量和有效性，推动金融行业数字化发展。',
    },
  },
];

const customerSimples = [
  {
    key: 'lexiang', icon: lexiang, link: '#',
  },
  {
    key: 'tencentQidian', icon: qidian, link: '#',
  },
  {
    key: 'game', icon: game, link: '#',
  },
  {
    key: 'tapd', icon: tapd, link: '#',
  },
  {
    key: 'map', icon: map, link: '#',
  },
  {
    key: 'healthcare', icon: healthcare, link: '#',
  },
  {
    key: 'andon', icon: andon, link: '#',
  },
  {
    key: 'midas', icon: midas, link: '#',
  },
];

const MAX_OFFSET = carousels.length - 3;

const DeepCustomers = () => {
  const carouselRef = useRef<HTMLDivElement>(null);
  const [current, setCurrent] = useState(0);
  const [isFirst, setIsFirst] = useState(true);
  const [isLast, setIsLast] = useState(false);

  useEffect(() => {
    const carouselWrap = carouselRef.current;
    if (carouselWrap) {
      carouselWrap.style.transform = `translateX(-${current * 434}px)`;
    }
    setIsFirst(current === 0);
    setIsLast(current === MAX_OFFSET);
  }, [current]);

  const gotoNext = () => {
    setCurrent(Math.min(current + 1, carousels.length - 3));
  };
  const gotoPre = () => {
    setCurrent(Math.max(current - 1, 0));
  };

  return (
    <div className={s.content}>
      <div className={s.carousel}>
        <div className={cn(s.toPre, s.btnWrap, isFirst && s.disabled)} onClick={gotoPre}>
          <img className={s.btn} src={toLeft} alt="" />
          <img className={s.disabledBtn} src={toLeftDiasbled} alt="" />
        </div>
        <div className={cn(s.toNext, s.btnWrap, isLast && s.disabled)} onClick={gotoNext}>
          <img className={s.btn} src={toRight} alt="" />
          <img className={s.disabledBtn} src={toRightDiasbled} alt="" />
        </div>
        <div className={s.carouselView}>
          <div className={s.carouselWrap} ref={carouselRef}>
            {
              carousels.map(item => (
                <div key={item.key} className={s.carouselItem}>
                  <div className={s.carouselImg}>
                    <img src={item.img} alt="" height={264} />
                  </div>
                  <div className={s.carouselContent}>
                    <div className={s.carouselIcon}>
                      {
                        item?.icon && <img src={item.icon} alt="" />
                      }
                    </div>
                    <div className={s.title}>{item.name}</div>
                    <div className={s.subTitle}>{item.subTitle}</div>
                    <div className={s.des}>{item.des}</div>
                  </div>
                </div>
              ))
            }
          </div>
        </div>
      </div>
      <div className={s.customerSimple}>
        {
          customerSimples.map(item => (
            <div key={item.key} className={s.simpleItem}>
              <img src={item.icon} className={s.cIcon} alt="" />
            </div>
          ))
        }
      </div>
    </div>
  );
};

export default DeepCustomers;
